export function isValidLongitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 180;
}

export function isValidLatitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 90;
}

/** A box around a point, for zooming the map to a single point. Returned as [west, south, east, north] */
export function getBoundsAroundPoint(lng: number, lat: number, paddingDegrees: number): [number, number, number, number] {
    return [lng - paddingDegrees, lat - paddingDegrees, lng + paddingDegrees, lat + paddingDegrees];
}
